function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m264.15 193.45c-19.523-19.527-51.184-19.527-70.711 0-19.523 19.527-19.523 51.184 0 70.711l81.496 81.492c-82.875 53.527-151.71 126.92-199.77 213.45-14.152 25.469-14.152 56.41 0 81.879 102.39 184.32 299.06 309.06 524.87 309.06 82.457 0 161.04-16.633 232.55-46.734l103.32 103.32c19.523 19.531 51.184 19.531 70.707 0 19.531-19.523 19.531-51.184 0-70.711zm473.75 615.17-73.199-73.199c-19.578 9.3672-41.516 14.617-64.668 14.617-82.848 0-150-67.152-150-150 0-23.152 5.25-45.09 14.621-64.668l-73.199-73.199c-26.176 39.52-41.422 86.914-41.422 137.87 0 138.07 111.93 250 250 250 50.953 0 98.348-15.242 137.87-41.418z",
    fillRule: "evenodd",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m850.05 600c0 18.176-1.9414 35.891-5.6211 52.965l149.59 149.59c52.449-45.695 96.879-100.37 130.9-161.61 14.148-25.473 14.148-56.41 0-81.883-102.39-184.32-299.06-309.06-524.86-309.06-48.832 0-96.301 5.832-141.75 16.84l88.777 88.781c17.078-3.6836 34.793-5.6211 52.969-5.6211 138.07 0 250 111.93 250 250z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosedIcon);
export default __webpack_public_path__ + "static/media/eyeClosed_icon.973eb5a0abcdc3d0cd991dc7bec07a7b.svg";
export { ForwardRef as ReactComponent };